import { useEffect, useRef, useState } from 'react';
import { AppState } from 'react-native';
import type { AppStateStatus } from 'react-native/Libraries/AppState/AppState';

// ─────────────────────────────────────────────────────────────────────

/**
 * @see {@link https://reactnative.dev/docs/appstate}
 */
export const useAppState = (params: Params = {}) => {
  const { onVisible, pause } = params;

  const appState = useRef(AppState.currentState);
  const [appStateVisible, setAppStateVisible] = useState<AppStateStatus>(
    appState.current,
  );

  useEffect(() => {
    if (pause) return;

    const subscription = AppState.addEventListener('change', (state) => {
      const isActive = state === 'active';
      const wasActive = appState.current === 'active';

      if (isActive && !wasActive) {
        onVisible?.();

        setAppStateVisible(appState.current);
      }

      // eslint-disable-next-line functional/immutable-data
      appState.current = state;
    });

    return () => {
      subscription.remove();
    };
  }, [onVisible, pause]);

  return appStateVisible;
};

// ─── Types ───────────────────────────────────────────────────────────

type Params = {
  pause?: boolean;
  onVisible?: () => void;
};
